import { FC } from 'react';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { ISize } from '@/types/cms';
import useTranslation from 'next-translate/useTranslation';
import { Props } from './types';
import { useRouter } from 'next/router';
import { handleCmsJump } from '../../tools/cms-link';

const Header: FC<Props> = props => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const {
    title,
    subTitle,
    moreLink,
    titleStyle,
    moreLinkStyle,
    trackingParams,
    as: Tag = 'div',
    className,
    cmsComponentKey,
    testId
  } = props;
  const { commonClick } = useClickActionT2();

  return (
    <>
      <div
        className={twMerge(
          'text-surface-100-fg-default flex justify-between items-center px-5 empty:hidden',
          className
        )}
        data-testid={`wid-header-${cmsComponentKey}`}>
        <h2
          data-testid={`txt-title-${cmsComponentKey}`}
          className={twMerge(
            classNames(
              'enki-body-base-medium overflow-hidden text-ellipsis whitespace-nowrap flex-1 pr-2',
              {
                '!text-[14px]': titleStyle?.font_size === (ISize.small as string)
              },
              {
                '!text-[17px]': titleStyle?.font_size === (ISize.middle as string)
              },
              {
                '!text-[20px]': titleStyle?.font_size === (ISize.large as string)
              }
            )
          )}
          style={{
            textAlign: titleStyle?.align,
            color: titleStyle?.color
          }}>
          {title || ''}
        </h2>

        {!!moreLink && (
          <Tag
            data-testid={testId ?? `btn-home-collection-${cmsComponentKey}-see-all`}
            className={twMerge(
              classNames(
                'enki-body-2xs-strong cursor-pointer flex-shrink-0 border border-solid border-surface-100-hairline px-[15px] py-[7px] rounded-full',
                {
                  '!text-[13px]': moreLinkStyle?.font_size === (ISize.small as string)
                },
                {
                  '!text-[14px]': moreLinkStyle?.font_size === (ISize.middle as string)
                },
                {
                  '!text-[16px]': moreLinkStyle?.font_size === (ISize.large as string)
                }
              )
            )}
            style={{
              color: moreLinkStyle?.color
            }}
            onClick={() => {
              commonClick({
                mod_nm: trackingParams?.mod_nm,
                mod_pos: trackingParams.mod_pos,
                sec_nm: trackingParams?.sec_nm || null,
                sec_pos: trackingParams?.sec_pos ?? null,
                co: {
                  target_nm: 'explore_more',
                  ...trackingParams.co
                },
                ctx: trackingParams.ctx
              });
              handleCmsJump(moreLink, router);
            }}>
            {t('see_all')}
          </Tag>
        )}
      </div>
      {!!subTitle && (
        <div
          data-testid={`txt-sub-title-${cmsComponentKey}`}
          className="mt-0.5 px-5 text-surface-100-fg-default enki-body-2xs-medium overflow-hidden whitespace-nowrap text-ellipsis">
          {subTitle}
        </div>
      )}
    </>
  );
};

export default Header;
